import { useCallback } from 'react';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { store } from 'Utilities/store';

/**
 * [Dialog types]
 * - couldn't find clinic
 * - already connected to clinc
 * - already send invite to clinic
 */
export const useCareTeamConnectionError = () => {
  const showClinicNotFoundErrorModal = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        testID: 'Connections.modals.clinicNotFound',
        details:
          "You can't share with this clinic practice because it is located in a different geographic region, or the practice ID is invalid.",
      },
    });
  }, []);

  const showAlreadyConnectedErrorModal = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        testID: 'Connections.modals.alreadyConnectedToClinic',
        details: 'You are already connected to this clinic.',
      },
    });
  }, []);

  const showAlreadyInvitedErrorModal = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        testID: 'Connections.modals.alreadySentInviteToClinic',
        details: "You've already sent an invitation to this clinic.",
      },
    });
  }, []);

  return {
    showClinicNotFoundErrorModal,
    showAlreadyConnectedErrorModal,
    showAlreadyInvitedErrorModal,
  };
};
